var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetSectionTitle from '@/Jetstream/SectionTitle';
export default function JetActionSection(_a) {
    var title = _a.title, description = _a.description, children = _a.children;
    return (_jsxs("div", __assign({ className: "md:grid md:grid-cols-3 md:gap-6" }, { children: [_jsx(JetSectionTitle, { title: title, description: description }), _jsx("div", __assign({ className: "mt-5 md:mt-0 md:col-span-2" }, { children: _jsx("div", __assign({ className: "px-4 py-5 sm:p-6 bg-white shadow sm:rounded-lg" }, { children: children })) }))] })));
}
